var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OptionArticle"},[_c('div',{staticClass:"topic"},[_vm._v(" "+_vm._s(_vm.article.topic)+" ")]),_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm._f("relativeTime")(_vm.article.createdAt))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }